// 请不要改动这个文件

let magicVar = `yhcKeepAlive`;

export default {
  data() {
    return {};
  },
  methods: {
    [`${magicVar}PushView`](identifierName) {
      if (!identifierName) {
        throw Error(`${magicVar}PushView : 必须传identifierName`);
      }
      this.$store.commit(`keepAlive/push`, identifierName);
    },
    [`${magicVar}UnshiftView`](identifierName) {
      if (!identifierName) {
        throw Error(`${magicVar}UnshiftView : 必须传identifierName`);
      }
      this.$store.commit(`keepAlive/unshift`, identifierName);
    },
    [`${magicVar}SetScrollItem`](identifierName, el) {
      if (!identifierName) {
        throw Error(`${magicVar}SetScrollItem : 必须传identifierName`);
      }
      if (!el) {
        throw Error(`${magicVar}SetScrollItem : 必须传el`);
      }
      this.$store.commit(`keepAlive/setScrollItem`, {
        identifierName,
        el,
      });
    },
    [`${magicVar}PatchScrollItem`](identifierName) {
      if (!identifierName) {
        throw Error(`${magicVar}PatchScrollItem : 必须传identifierName`);
      }
      this.$store.commit(`keepAlive/patchScrollItem`, {
        identifierName,
      });
    },
  },
};
